/**
 * Sticky Header
 * Adds a class to header on scroll
 */

import '../vendors/organic-tab';
import slick from '../vendors/slick.min';
import OwlCarousel from '../vendors/owl.carousel.min';
import '../vendors/jquery-magnificpopup.js';
jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );

jQuery( function() {
	if ( navigator.userAgent.indexOf( 'Mac OS X' ) != -1 ) {
		jQuery( 'body' ).addClass( 'style-for-apple' );
	} else {
		jQuery( 'body' ).addClass( 'style-for-window' );
	}
	jQuery( 'a.video' ).magnificPopup( {
		type: 'iframe',
	} );

	jQuery( '.menu-item-has-children > a' ).focus( function() {
		jQuery( this ).siblings( '.sub-menu' ).addClass( 'focused' );
	  } ).blur( function() {
		jQuery( this ).siblings( '.sub-menu' ).removeClass( 'focused' );
	  } );

	// For children
	jQuery( '.sub-menu a' ).focus( function() {
		jQuery( this ).parents( '.sub-menu' ).addClass( 'focused' );
	} ).blur( function() {
		jQuery( this ).parents( '.sub-menu' ).removeClass( 'focused' );
	} );
	const body = jQuery( 'body' );
	if ( jQuery( '.page-template-template-our-school' ).length > 0 ) {
		if ( body.hasClass( 'page-template-template-our-school' ) ) {
			jQuery( 'html' ).addClass( 'scroll-behavior-normal' );
		}
	}

	if ( jQuery( '.hero-default-row' ).length > 0 ) {
		jQuery( '.hero-default-row' ).each( function() {
			const thisHeight = jQuery( this ).height();

			if ( thisHeight > 530 ) {
				jQuery( this ).addClass( 'have-extra-height' );
			}
		} );
	}

	if ( jQuery( '.single' ).length > 0 ) {
		if ( body.hasClass( 'single-post' ) || body.hasClass( 'single-school' ) ) {
			jQuery( '#footer-section' ).addClass( 'is-blue-bg' );
		}
	}

	/**
	 * Our Schools Listing
	 */

	jQuery( '.latest-post-slider' ).slick( {
		infinite: true,
		speed: 300,
		slidesToShow: 1,
	} );

	// JavaScript code
	jQuery( '.show-list' ).on( 'click', function( event ) {
		event.preventDefault();
		if ( jQuery( '.our-schools-detail' ).parent().parent().hasClass( 'schools-locations' ) ) {
			jQuery( this ).text( 'Show Map' );
			jQuery( '.our-schools-detail' ).parent().parent().removeClass( 'schools-locations' );
			jQuery( 'body' ).removeClass( 'body-schools-locations' );
		} else {
			jQuery( this ).text( 'Show List' );
			jQuery( '.our-schools-detail' ).parent().parent().addClass( 'schools-locations' );
			jQuery( 'body' ).addClass( 'body-schools-locations' );
		}
		jQuery( this ).toggleClass( 'map-view' );
	} );

	// jQuery('header').css('padding','0');
	// console.log(add_style);

	/**
	 * Toggle menu for mobile
	 */
	jQuery( '.menu-btn' ).click( function() {
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.nav-overlay' ).toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );
	jQuery.noConflict();

	// Toggle search form on search icon click
	jQuery( '.header-search-icon' ).click( function( e ) {
		e.stopPropagation(); // Prevents the click event from reaching the body

		// Toggle the active class for the search form
		jQuery( '.header-search-form' ).toggleClass( 'active' );
	} );

	// Close search form when clicking outside of it
	jQuery( 'body' ).click( function() {
		// Remove active class from search form
		jQuery( '.header-search-form' ).removeClass( 'active' );
	} );

	// Prevent closing search form when clicking inside it
	jQuery( '.header-search-form' ).click( function( e ) {
		e.stopPropagation();
	} );

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */
	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this )
				.find( 'a:first' )
				.after( '<span class="submenu-icon"></span>' );
		}
	} );

	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */
	jQuery( '.header-nav .submenu-icon, .select-dropdown-header .submenu-icon' ).click( function() {
		const link = jQuery( this );
		const closestUl = link.closest( 'ul' );
		const parallelActiveLinks = closestUl.find( '.active' );
		const closestLi = link.closest( 'li' );
		const linkStatus = closestLi.hasClass( 'active' );
		let count = 0;

		closestUl.find( 'ul' ).slideUp( function() {
			if ( ++count === closestUl.find( 'ul' ).length ) {
				parallelActiveLinks.removeClass( 'active' );
			}
		} );

		if ( ! linkStatus ) {
			closestLi.children( 'ul' ).slideDown();
			closestLi.addClass( 'active' );
		}
	} );

	jQuery.noConflict();

	/**
	 * Header More Popups
	 */

	jQuery( '.more-btn-title' ).on( 'click focus', function() {
		jQuery( '.more-popup,.more-popup-overlay' ).addClass( 'show' );
	} ).on( 'focusout', function() {
		jQuery( '.more-popup,.more-popup-overlay' ).addClass( 'show' );
	} );

	jQuery( '.more-btn-close' ).on( 'click', function() {
		jQuery( '.more-popup,.more-popup-overlay' ).removeClass( 'show' );
	} );
	jQuery( '.menu-header-more-menu-container .menu a' ).focus( function() {
		jQuery( this ).parents( '.more-popup' ).addClass( 'show' );
		jQuery( '.more-popup-overlay' ).addClass( 'show' );
	} );
	jQuery( '.menu-header-more-menu-container .menu a' ).focusout( function() {
		jQuery( this ).parents( '.more-popup' ).removeClass( 'show' );
		jQuery( '.more-popup-overlay' ).removeClass( 'show' );
	} );

	jQuery( document ).mouseup( function( e ) {
		const container = jQuery( '.more-popup' );
		// if the target of the click isn't the container nor a descendant of the container
		if ( ! container.is( e.target ) && container.has( e.target ).length === 0 ) {
			jQuery( '.more-popup,.more-popup-overlay' ).removeClass( 'show' );
		}
	} );

	/**
	 * Video popup
	 */

	jQuery( 'a.team-popup' ).magnificPopup( {
		type: 'inline',
		midClick: true,
		mainClass: 'team-popup-ctn',
	} );
	jQuery( document ).on( 'click', '.popup-close-btn', function( e ) {
		e.preventDefault();
		jQuery.magnificPopup.close();
	} );
	if ( jQuery( '#school-popup-ctn' ).length ) {
	   jQuery.magnificPopup.open( {
	    items: {
	        src: '#school-popup-ctn',
	    },
	    type: 'inline',
	      } );
	   }

	/**
	 * Quote Tile slider
	 */
	if ( jQuery( window ).width() < 748 ) {
		jQuery( '.quote-tile-slider' ).owlCarousel( {

		  margin: 20,
		  responsiveClass: true,
		  stagePadding: 20,
		  autoHeight: true,
		  dots: false,
		  nav: false,
		  responsive: {
		    0: {
		      items: 1,
		    },

		    600: {
		      items: 2,
		    },
		  },
		} );
		// jQuery( '.quote-tile-slider' ).slick( {
		// 	slidesToShow: 2,
		// 	slidesToScroll: 1,
		// 	dots: false,
		// 	arrows: false,
		// 	variableWidth: false,
		// 	infinite: false,
		// 	responsive: [
		// 		{
		// 			breakpoint: 680,
		// 			settings: {
		// 				slidesToShow: 2,
		// 			},
		// 		},
		// 		{
		// 			breakpoint: 430,
		// 			settings: {
		// 				slidesToShow: 1,
		// 			},
		// 		},
		// 	],
		// } );
	}
	/**
	 * Post-archive
	 */
	if ( jQuery( window ).width() < 748 ) {
		jQuery( '.post-slider' ).slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			arrows: false,
			variableWidth: true,
			infinite: false,
		} );
	}

	jQuery( '.wpml-ls-statics-shortcode_actions ul li' ).addClass( 'dropdown-list-title' );

	/**
	 *
	 *
	 * Script for Mobile Filter
	 *
	 */
	if ( jQuery( window ).width() < 1003 ) {
		jQuery( '.filter-mobile' ).on( 'click', function() {
			const $this = jQuery( this );
			const $filters = $this.siblings( '.schools-filters' );
			$this.toggleClass( 'filter-mobile-button-active' );

			if ( $this.hasClass( 'filter-mobile-button-active' ) ) {
				$filters.slideDown();
			} else {
				$filters.slideUp();
			}
		} );
	}
	/**
	 *
	 *
	 * Script for Header Mobile
	 *
	 */
	jQuery( '.mobile-drop-down' ).on( 'click', function() {
		const $this = jQuery( this );
		const $parentDropdown = $this.closest( '.select-dropdown' );
		const $allDropdowns = jQuery( '.select-dropdown' );
		// Slide up all other dropdowns except the clicked one
		$allDropdowns.not( $parentDropdown ).removeClass( 'mobile-dropdown-active' )
			.find( '.js-mobile-dropdown-content' ).slideUp();
		// Toggle the class and slide the dropdown content of the clicked one
		$parentDropdown.toggleClass( 'mobile-dropdown-active' )
			.find( '.js-mobile-dropdown-content' ).slideToggle();
	} );

	jQuery.noConflict();

	const boxes = document.querySelectorAll( '.cream-dot' );

	function revealOnScroll() {
		const windowHeight = window.innerHeight;

		boxes.forEach( ( box, index ) => {
			const boxTop = box.getBoundingClientRect().top;

			if ( boxTop < windowHeight * 0.75 ) {
				if ( ! box.classList.contains( 'scaled' ) ) {
					setTimeout( () => {
						box.classList.add( 'scaling-up' );
						setTimeout( () => {
							box.classList.remove( 'scaling-up' );
							box.classList.add( 'scaled' );
						}, 800 );
					}, index * 300 );
				}
			}
		} );
	}

	window.addEventListener( 'scroll', revealOnScroll );

	const boxes1 = document.querySelectorAll( '.iat-round-image' );

	function revealOnScroll1() {
		const windowHeight = window.innerHeight;

		boxes1.forEach( ( box, index ) => {
			const boxTop = box.getBoundingClientRect().top;

			if ( boxTop < windowHeight * 0.75 ) {
				if ( ! box.classList.contains( 'scaled' ) ) {
					setTimeout( () => {
						box.classList.add( 'scaling-up' );
						setTimeout( () => {
							box.classList.remove( 'scaling-up' );
							box.classList.add( 'scaled' );
						}, 800 );
					}, index * 300 );
				}
			}
		} );
	}

	window.addEventListener( 'scroll', revealOnScroll1 );

	/*
	*
	*	* Header Buttons dropdowns
	*
	* */

	jQuery( '.select-dropdown__button' ).on( 'click', function( e ) {
		const dropdown = jQuery( this ).closest( '.select-dropdown' );
		dropdown.find( '.select-dropdown__button' ).toggleClass( 'is-button-opened' );
		dropdown.find( '.select-dropdown__list' ).toggleClass( 'is-active-dropdown' );
	} ).on( 'focus', function( e ) {
		setTimeout( () => {
			const dropdown = jQuery( this ).closest( '.select-dropdown' );
			dropdown.find( '.select-dropdown__button' ).addClass( 'is-button-opened' );
			dropdown.find( '.select-dropdown__list' ).addClass( 'is-active-dropdown' );
		}, 100 );
	} ).on( 'focusout', function() {
		const dropdown = jQuery( this ).closest( '.select-dropdown' );
		dropdown.find( '.select-dropdown__button' ).removeClass( 'is-button-opened' );
		dropdown.find( '.select-dropdown__list' ).removeClass( 'is-active-dropdown' );
	} );

	jQuery( '.dropdown-list-title' ).on( 'click keypress', function( e ) {
		if ( e.which === 13 || e.which === 1 ) {
			const dropdown = jQuery( this ).closest( '.select-dropdown' );
			const ratioText = 'Ratio';
			const itemValue = jQuery( this ).data( ratioText );

			dropdown.find( '.select-dropdown__button' ).toggleClass( 'is-button-opened' );
			dropdown.find( '.select-dropdown__list' ).toggleClass( 'is-active-dropdown' );

			jQuery( this ).parents( '.select-dropdown' ).find( '.select-dropdown__button' ).text( jQuery( this ).text() ).parents().attr( 'data-value', itemValue );
		}
	} );

	jQuery( '.dropdown-list-title' ).focus( function() {
		jQuery( this ).parent( '.hero-select-dropdown' ).addClass( 'is-active-dropdown' );
		jQuery( this ).parent( '.select-dropdown__list' ).addClass( 'is-active-dropdown' );
	} ).focusout( function() {
		jQuery( this ).parent( '.hero-select-dropdown' ).removeClass( 'is-active-dropdown' );
		jQuery( this ).parent( '.select-dropdown__list' ).removeClass( 'is-active-dropdown' );
	} );

	/*
		* Close popup on anywhere click
		*/

	jQuery( document ).mouseup( function( e ) {
		const container = jQuery( '.select-dropdown__list' );
		const dropdowns = jQuery( '.select-dropdown' );
		dropdowns.each( function() {
			const dropdown = jQuery( this );
			const button = dropdown.find( '.select-dropdown__button' );
			const list = dropdown.find( '.select-dropdown__list' );
			if ( ! list.is( e.target ) && list.has( e.target ).length === 0 && ! button.is( e.target ) && button.has( e.target ).length === 0 ) {
				list.removeClass( 'is-active-dropdown' );
				button.removeClass( 'is-button-opened' );
			}
		} );
	} );
	jQuery( document ).on( 'keypress', '.filter-group', function( e ) {
		if ( e.which == 13 ) {
			jQuery( this ).find( '.school-filter-item' ).click();
		}
	} );
	jQuery( document ).on( 'click', '.school-ajax-apply,.school-filter-item', function() {
		const city = [];
		const grade = [];
		const page = jQuery( this ).attr( 'data-page' );
		const language = jQuery( '.school-ajax-lang' ).attr( 'data-language' );
		// console.log( language );
		const isBlock = jQuery( this ).attr( 'data-block' );
		if ( isBlock !== 'is_block' ) {
			var blocked = false;
			jQuery( '.school-filter-item:checked' ).each( function() {
				if ( jQuery( this ).attr( 'data-type' ) === 'city' ) {
					city.push( jQuery( this ).attr( 'id' ) );
				} else {
					grade.push( jQuery( this ).attr( 'id' ) );
				}
				// console.log( 'template' );
			} );
		} else {
			// console.log( 'block' );
			blocked = true;
			jQuery( '.school-filter-items:checked' ).each( function() {
				city.push( jQuery( this ).attr( 'id' ) );
			} );
			jQuery( '.school-filter-item:checked' ).each( function() {
				grade.push( jQuery( this ).attr( 'id' ) );
			} );
		}
		if ( isBlock !== 'is_block' ) {
		// console.log( grade, city, page );
			if ( history.pushState ) {
				let oldurl = window.location.protocol + '//' + window.location.host + window.location.pathname;
				if ( grade.length > 0 && city.length > 0 ) {
					oldurl += '?grade=' + grade + '&city=' + city;
				} else if ( city.length > 0 ) {
					oldurl += '?city=' + city;
				} else if ( grade.length > 0 ) {
					oldurl += '?grade=' + grade;
				}

				if ( parseInt( page ) !== 1 ) {
					if ( oldurl.indexOf( '?' ) === -1 ) {
						oldurl += '?current-page=' + page;
					} else {
						oldurl += '&current-page=' + page;
					}
				}
				const currentUrl = window.location.href;
			    if ( currentUrl.indexOf( 'lang=es' ) !== -1 ) {
			        oldurl += '&lang=es';
			    }

				window.history.pushState( { path: oldurl }, '', oldurl );
			}
		}
		const data = {
			action: 'school_filter',
			items: {
				grade, city,
			},
			page, blocked, language,
			nonce: localVars.nonce,
		};
		jQuery( '.popup-error-message' ).remove();
		jQuery( '.lds-roller' ).show();
		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'post',
			data,
			dataType: 'json',
			success( response ) {
				// console.log( blocked );
				if ( isBlock !== 'is_block' ) {
					locationVars.results = response.results_arr;
					setTimeout( initMap, 500 );
				}

				// hideItems( jQuery.merge( response.cities, response.grades ) );
				jQuery( '.schools-details' ).html( response.html );
				jQuery( '.lds-roller' ).hide();
				jQuery( 'html, body' ).animate(
					{
						scrollTop: jQuery( '#scroll-to-here' ).offset().top - 200,
					},
					1000
				);
				if ( 'yes' === response.nonep ) {
					jQuery( '.schools-details' ).after( response.no_msg );
				}
			},
		} );
	} );

	jQuery( document ).on( 'click', '.school-ajax-reset', function() {
		jQuery( '.school-filter-item' ).each( function() {
			jQuery( this ).prop( 'checked', false );
		} );
		if ( history.pushState ) {
			const oldurl = window.location.protocol + '//' + window.location.host + window.location.pathname;
			window.history.pushState( { path: oldurl }, '', oldurl );
		}
		jQuery( '.school-ajax-apply[data-type="btn"]' ).click();
	} );

	function hideItems( terms ) {
		// console.log( terms );
		jQuery( '.school-filter-item' ).each( function() {
			jQuery( this ).parent().parent().addClass( 'unactive' );
		} );
		for ( const key in terms ) {
			const term = terms[ key ];
			jQuery( '#' + term.slug ).parent().parent().removeClass( 'unactive' );
			jQuery( '#' + term.slug ).find( 'span' ).text( term.count );
		}
	}
	jQuery( '.home-hero-dropdowns .hero-location-dropdown li' ).on( 'click', function() {
		jQuery( '.city-hidden' ).val( jQuery( this ).data( 'slug-city' ) );
	} );
	jQuery( '.home-hero-dropdowns .hero-grade-dropdown li' ).on( 'click', function() {
		jQuery( '.grade-hidden' ).val( jQuery( this ).data( 'slug-grade' ) );
	} );
	jQuery.noConflict();
	jQuery( '.select-dropdown #block-dropdown-city li' ).on( 'click', function() {
		jQuery( '.city-hidden' ).val( jQuery( this ).data( 'slug-city' ) );
	} );
	jQuery( '.select-dropdown #block-dropdown-grade li' ).on( 'click', function() {
		jQuery( '.grade-hidden' ).val( jQuery( this ).data( 'slug-grade' ) );
	} );

	if ( jQuery( window ).width() > 1003 ) {
		jQuery( document ).on( 'scroll', function() {
			const scrollPosition = jQuery( document ).scrollTop();
			const footerSectionOffset = jQuery( '#footer-section' ).offset().top;

			if ( scrollPosition > ( footerSectionOffset - 1000 ) ) {
				jQuery( '.box-popup' ).removeClass( 'show' );
				jQuery( '.map-button' ).hide();
			} else if ( scrollPosition > 1000 ) {
				jQuery( '.box-popup' ).addClass( 'show' );
				jQuery( '.map-button' ).show();
			} else {
				jQuery( '.box-popup' ).removeClass( 'show' );
				jQuery( '.map-button' ).show();
			}
		} );
	}

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( document ).on( 'scroll', function() {
			const scrollPosition = jQuery( document ).scrollTop();
			const footerSectionOffset = jQuery( '#footer-section' ).offset().top;

			if ( scrollPosition > ( footerSectionOffset - 1100 ) ) {
				jQuery( '.box-popup' ).removeClass( 'show' );
				jQuery( '.map-button' ).hide();
			} else if ( scrollPosition > 1000 ) {
				jQuery( '.box-popup' ).addClass( 'show' );
				jQuery( '.map-button' ).show();
			} else {
				jQuery( '.box-popup' ).removeClass( 'show' );
				jQuery( '.map-button' ).show();
			}
		} );
	}

	jQuery( '.page-template-template-our-school .map-button' ).on( 'click', function() {
		jQuery( '.page-template-template-our-school' ).toggleClass( 'show-button-forcely' );
	} );

	jQuery(
		( function( jQuery, win ) {
			jQuery.fn.inViewport = function( cb ) {
				return this.each( function( i, el ) {
					function visPx() {
						const H = jQuery( this ).height(),
							r = el.getBoundingClientRect(),
							t = r.top,
							b = r.bottom;
						return cb.call( el, Math.max( 0, t > 0 ? H - t : b < H ? b : H ) );
					}
					visPx();
					jQuery( win ).on( 'resize scroll', visPx );
				} );
			};
		} )( jQuery, window )
	);
	jQuery( '.social-cta-images' ).inViewport( function( px ) {
		//  = Animate numbers
		if ( px > 300 && ! this.initNumAnim ) {
			this.initNumAnim = true; // Set flag to true to prevent re-running the same animation
			jQuery( this ).addClass( 'active' );
		}
	} );

	//stats

	if ( jQuery( '.stats-cta' ).length > 0 ) {
		const a = [];

		function isElementInViewport( el ) {
			const rect = el.getBoundingClientRect();
			return (
				rect.bottom > 0 &&
        rect.right > 0 &&
        rect.left < ( window.innerWidth || document.documentElement.clientWidth ) &&
        rect.top < ( window.innerHeight || document.documentElement.clientHeight )
			);
		}

		jQuery( window ).on( 'scroll', function() {
			jQuery( '.stats-cta' ).each( function( index ) {
				if ( ! a[ index ] && isElementInViewport( this ) ) {
					jQuery( this ).find( '.stat-number' ).each( function() {
						const $this = jQuery( this ),
							countTo = $this.attr( 'data-number' );
						jQuery( { countNum: $this.text() } ).animate(
							{
								countNum: countTo,
							},
							{
								duration: 5000,
								easing: 'swing',
								step() {
									$this.text( Math.ceil( this.countNum ).toLocaleString( 'en' ) );
								},
								complete() {
									$this.text( Math.ceil( this.countNum ).toLocaleString( 'en' ) );
								},
							}
						);
					} );
					a[ index ] = true;
				}
			} );
		} );

		// Trigger scroll event on initial page load to check if elements are in viewport.
		jQuery( window ).trigger( 'scroll' );
	}
	jQuery( document ).on( 'keypress', '.school-ajax-apply', function( e ) {
		if ( e.which == 13 ) {
			jQuery( this ).click();
		}
	} );
	jQuery( document ).on( 'keypress', '.faq-head-area', function( e ) {
		if ( e.which == 13 ) {
			jQuery( this ).click();
		}
	} );
	jQuery( '.page-section p' ).attr( {
	  role: 'heading',
	  'aria-level': '4',
	} );
} );
